{% block ecocode_trustpilot_overview %}
    <sw-page class="ecocode-trustpilot-overview">
        <template #content>
            <sw-card-view>
                <sw-loader v-if="isLoading"></sw-loader>
                <template v-else>
                    <sw-card>

                        <sw-empty-state
                                :absolute="false"
                                :icon="'default-action-settings'"
                                v-show="status !== 'ok'"
                                :title="$tc('ecocode-trustpilot.overview.notConfiguredTitle')"
                        >
                            <div>
                                {{ $tc('ecocode-trustpilot.overview.notConfiguredSubline') }}
                            </div>
                            <div>
                                <br>
                                <sw-button variant="primary"
                                           :routerLink="{name: 'ecocode.trustpilot.setup.connect'}">
                                    {{ $tc('ecocode-trustpilot.overview.configureButtonText') }}
                                </sw-button>
                            </div>
                        </sw-empty-state>

                        <div v-for="unitDetails in businessUnits">
                            <h2>{{ unitDetails.businessUnit.displayName }} ({{ unitDetails.salesChannelsString }})</h2>
                            <strong>{{ $tc('ecocode-trustpilot.review.ratingLine',null,{score: unitDetails.businessUnit.score.trustScore, total: unitDetails.businessUnit.numberOfReviews.total}) }}</strong>

                            <div class="ecocode-trustpilot-overview__review"
                                 v-for="review in unitDetails.recentReviews.reviews">
                                <svg viewBox="0 0 512 512"
                                     class=" ecocode-trustpilot-overview__review__quote css-w863cj-Icon"
                                     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                     aria-hidden="true" focusable="false" role="img">
                                    <path fill="currentColor"
                                          d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"></path>
                                </svg>
                                <div class="ecocode-trustpilot-overview__review__title">{{ review.text }}</div>
                                <div class="ecocode-trustpilot-overview__review__content">
                                    <img class="ecocode-trustpilot-overview__review__stars"
                                         :src="'https://cdn.trustpilot.net/brand-assets/4.0.0/stars/stars-' + review.stars + '.svg'"
                                         :alt="review.stars">
                                    <span>{{ $tc('ecocode-trustpilot.review.quoteLine',null,{ date: review.createdAt }) }}</span>
                                </div>
                            </div>
                        </div>
                    </sw-card>
                </template>
            </sw-card-view>
        </template>
    </sw-page>
{% endblock %}
